<template>
  <div>
<printSheet>
      <div slot="printContent" id="printArea" class="saleBill" ref="printArea">
        <!-- 打印11545 -->

 <div v-if='type===2' slot="printContent" id="printArea" class="saleBill2">
          <div v-for="(page,i) in pages.all " :key="i">

          <h2 class="sheetTitle">
            {{ baseInfo.storeInfo.name }}
          </h2>
          <table class="printTable">
            <thead>
              <tr>
                <td><span>品名</span></td>
                <td><span>规格</span></td>
                <td><span>厂商</span></td>
                <td v-if="data.retailType !== 3"><span>上市许可<br/>持有人</span></td>
                <td><span>产地</span></td>
                <td><span>批号</span></td>
                <td><span>单价</span></td>
                <td><span>优惠价</span></td>
                <td><span>数量</span></td>
                <td><span>金额</span></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in data.goodsList.slice((page-1)*pages.size,(page)*pages.size)" :key="index">

                <td>
                  <span>

                  <span v-if="item.isRxPrescription === 1" class="specialText">单</span>
                  <span v-if="item.isRxRegister === 1" class="specialText">双</span>
                  <span v-if="item.isExpring === 1" class="specialText">近</span>
                  <span v-if="item.isColdChain === 1" class="specialText">冷</span>
                  <span v-if="item.isEphedrineDrugs === 1" class="specialText">麻</span>
                  <span v-if="item.isDope === 1" class="specialText">兴</span>
                  <span v-if="item.isMedicare === 1" class="specialText">医</span>
                  <span>{{item.saleOrderDetail.approvedDrugNames}}</span>
                  </span>
                  </td>
                <td><span>{{item.saleOrderDetail.specifications}}</span></td>
                <td><span>{{item.saleOrderDetail.manufacturer}}</span></td>
                <td v-if="data.retailType !== 3"><span>{{item.mah}}</span></td>
                <td><span>{{item.saleOrderDetail.origin}}</span></td>
                <td><span>{{item.saleOrderDetail.goodsLot}}</span></td>
                <td><span>{{item.saleOrderDetail.retailPrice}}</span></td>
                <td><span>{{item.saleOrderDetail.realPrice}}</span></td>
                <td><span>{{item.saleOrderDetail.goodsCount}}</span></td>
                <td>
                  <span>{{(item.saleOrderDetail.realPrice*item.saleOrderDetail.goodsCount).toFixed(6)*1}}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div style="display:flex; justify-content: space-between">
            <div style="width:33%">
              <span>会员等级:</span>
              <span>无</span>
            </div>
            <div style="width:33%">
              <span>总计:</span>
              <span>{{ data.saleOrder.totalAmountDisplay+'元' }}</span>
            </div>
            <div style="width:33%">
              <span>实收总计:</span>
              <span>{{ data.realProceedsAmount+'元' }}</span>
            </div>
          </div>
          <div style="display:flex; justify-content: space-between">
            <div style="width:33%;display:flex;flex-wrap:wrap">
              <span>收款方式:</span>
              <span v-for="(item,index) in data.proceedsList" :key="index" class="mr8">
                <span>{{ item.proceedsTypeName+'：' }}</span>
                <span>{{ item.amount+'元' }}</span>

              </span>
            </div>
            <div style="width:33%">
              <span>折扣金额:</span>
              <span>{{ data.cutPrice+'元' }}</span>
            </div>
            <div style="width:33%">
              <span>找零金额:</span>
              <span>{{ data.changeAmount||0+'元' }}</span>
            </div>
          </div>
          <div style="display:flex; justify-content: space-between">
            <div style="width:33%" v-if="data.salePrescription">
              <span>患者姓名:</span>
              <span>{{ data.salePrescription.patientName }}</span>
            </div>
            <div style="width:33%">
              <span>销售单号:</span>
              <span>{{ data.saleOrder.orderNo }}</span>
            </div>
            <div style="width:33%">
              <span>交易时间:</span>
              <span>{{ data.saleOrder.createTime|formatDateToMin }}</span>
            </div>
          </div>
          <div style="display:flex; justify-content: space-between">
            <div style="width:33%">
              <span>药房电话:</span>
              <span>{{ baseInfo.storeInfo.phone }}</span>
            </div>
            <div style="width:66%">
              <span>药房地址:</span>
              <span>{{ baseInfo.storeInfo.address}}</span>
            </div>
            </div>
            <div style="display:flex; justify-content: space-between"  v-if="data.retailType === 1">
              <div style="width:33%"><span class="specialText">单</span><span>为单轨处方药</span></div>
              <div style="width:33%"><span class="specialText">双</span><span>为双轨处方药</span></div>
              <div style="width:33%"><span class="specialText">近</span><span>为近效期药品</span></div>
            </div>
            <div style="display:flex; justify-content: space-between" v-if="data.retailType === 1">

              <div style="width:33%"><span class="specialText">冷</span><span>为冷链药品</span></div>
              <div style="width:33%"><span class="specialText">麻</span><span>为含麻黄碱类药品 </span></div>
              <div style="width:33%"><span class="specialText">兴</span><span>为含兴奋剂成分药品，运动员慎用！</span></div>

            </div>
            <!-- 是否医保 -->
            <div style="display:flex; justify-content: space-between" v-if="data.retailType === 1">
              <div><span class="specialText">医</span><span>为医保药品</span></div>
            </div>

            <div class="userInfo">药品为特殊商品，除质量原因外，一经售出概不退换！</div>
          </div>

          </div>
        <div v-else class="bill">
           <div class="sheetTitle">
            {{ baseInfo.storeInfo.name }}
          </div>
          <div v-if="$store.state.medicalAuth">
            <div>
              <span>零售药店代码:</span>&nbsp;
              <span>{{data.saleOrder.drugStoreCode || ''}}</span>
            </div>
            <div>
              <span>药师姓名:</span>&nbsp;
              <span>{{data.saleOrder.apothecaryName || ''}}</span>
            </div>
            <div>
              <span>医保药师代码:</span>&nbsp;
              <span>{{data.saleOrder.apothecaryMedListCodg || ''}}</span>
            </div>
          </div>
          <table class="table" v-if="data.retailType === 3"> <!-- 中药饮片3，普通药品1 -->
            <tr>
              <td>品名&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>规格&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>产地&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>斗柜&nbsp;&nbsp;&nbsp;&nbsp;</td>
            </tr>
            <tr>
              <td>厂商&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>批号&nbsp;&nbsp;&nbsp;&nbsp;</td>
            </tr>
            <tr>
              <td>单价&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>优惠价&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>数量&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>金额&nbsp;&nbsp;&nbsp;&nbsp;</td>
            </tr>
            <tr v-if="$store.state.medicalAuth">
              <td>医保药品编码</td>
            </tr>
          </table>
          <table class="table" v-else>
            <tr>
              <td>品名&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td v-if='ifShowDosageform'>规格(剂型)&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td v-else>规格&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>厂商&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>批号&nbsp;&nbsp;&nbsp;&nbsp;</td>
            </tr>
            <tr>
              <td>单价&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>优惠价&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>数量&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>金额&nbsp;&nbsp;&nbsp;&nbsp;</td>
            </tr>
            <tr>
              <td>上市许可持有人</td>
              <td v-if="$store.state.medicalAuth">医保药品编码</td>
              <td>有效期</td>
            </tr>
          </table>
          <div class="spLine"></div>
          <div v-for="(item,index) in data.goodsList" :key="index" >
              <div class="blockDisplay">
                <div>·</div>
                <div style="width:2%"></div>
                <div style="width:50%;" class="firstRowDrug">
                {{ item.saleOrderDetail.approvedDrugNames }}</div>
                <div style="width:3%"></div>
                <div style="width:45%" class="firstRowDrug">{{ ifShowDosageform ? `${item.saleOrderDetail.specifications}${item.saleOrderDetail.dosageForm ? item.saleOrderDetail.dosageForm : ''}` : item.saleOrderDetail.specifications}}</div>
              </div>
              <div class="blockDisplay" v-if="data.retailType === 3">
                <div style="width:52%" class="firstRowDrug">{{ item.saleOrderDetail.origin }}</div>
                <div style="width:3%"></div>
                <div style="width:45%" class="firstRowDrug">{{ item.saleOrderDetail.allocationName }}
                </div>
              </div>
              <div v-if="data.retailType === 1">
                <div class="userInfoMessage2 ">
                  <span v-if="item.isRxPrescription === 1" class="specialText">单</span>
                  <span v-if="item.isRxRegister === 1" class="specialText">双</span>
                  <span v-if="item.isExpring === 1" class="specialText">近</span>
                  <span v-if="item.isEphedrineDrugs === 1" class="specialText">麻</span>
                  <span v-if="item.isColdChain === 1" class="specialText">冷</span>
                  <span v-if="item.isDope === 1" class="specialText">兴</span>
                  <span v-if="item.isMedicare === 1" class="specialText">医</span>
                </div>
              </div>
              <div class="blockDisplay">
                <div style="width:50%" class="firstRowDrug">{{ item.saleOrderDetail.manufacturer }}</div>
                <div style="width:5%"></div>
                <div style="width:45%" class="firstRowDrug">{{ item.saleOrderDetail.goodsLot }}</div>
              </div>
              <div class="blockDisplay">
                <div style="width:100%">{{ item.saleOrderDetail.retailPrice}}元&nbsp;&nbsp;     
                 {{ item.saleOrderDetail.realPrice }} × 
                 {{ item.saleOrderDetail.goodsCount }}{{ item.saleOrderDetail.goodsUnit }} = 
                 {{ item.saleOrderDetail.amount }}</div>
              </div>
              <div v-if="data.retailType === 1" style="width:100%,overflow:hidden">{{item.mah}}</div>
              <div v-if="$store.state.medicalAuth">{{ item.saleOrderDetail.medListCodg || ''}}</div>
              <span>有效期至{{item.saleOrderDetail.expireDate| formatDate}}</span>
            </div>
          <div class="spLine"></div>
          <div class="subTable bottomMargin">
            <span>
              <span>会员等级：</span>
              <span>无</span>
            </span>
            <span>
              <span>总计：</span>
              <span>{{ data.saleOrder.totalAmountDisplay+'元' }}</span>
            </span>
          </div>
          <div class="bottomMargin">
            <span>订单金额：</span>
            <span>{{ data.saleOrder.totalAmountDisplay+'元' }}</span>
          </div>
          <div class="bottomMargin">
            <span>折扣金额：</span>
            <span>{{ data.cutPrice||0}}元</span>
          </div>
          <div class="payData">
            <div class="proceeds">
              <div class="paymentType">
                <div>
                  <table>
                    <tr v-for="(item,index) in data.proceedsList" :key="item.id">
                      <td>
                        <span class="insert" v-if="index===0">收款方式：</span>
                      </td>
                      <td>
                        <span>{{ item.proceedsTypeName+'：' }}</span>
                        <span>{{ item.amount+'元' }}</span>
                      </td>
                    </tr>
                  </table>

                </div>
              </div>
            </div>
            <div class="bottomMargin">
              <span>找零金额：</span>
              <span>{{ data.changeAmount||0}}元</span>
            </div>
          </div>
          <div class="bottomMargin">
            <span>实收总计：</span>
            <span>{{data.realProceedsAmount + '元'}}</span>
          </div>
          <div class="bottomMargin" v-if="data.amountToProceeds">
            <span>剩余应收：</span>
            <span>{{data.amountToProceeds + '元'}}</span>
          </div>
          <div class="bottomMargin" v-if="data.insurance">
            <span>统筹支付：</span>
            <span>{{data.insurance.planTotalAmount + '元'}}</span>
          </div>
          <div class="bottomMargin" v-if="data.insurance">
            <span>个人现金支付：</span>
            <span>{{data.insurance.cashAmount + '元'}}</span>
          </div>
          <div class="bottomMargin" v-if="data.insurance">
            <span>个人账户支付：</span>
            <span>{{data.insurance.insuranceAmount + '元'}}</span>
          </div>
          <div class="infos">
            <div class="userInfo bottomMargin" v-if="data.salePrescription || data.insurance">患者姓名：{{ data.insurance ? data.insurance.userName : (data.salePrescription ? data.salePrescription.patientName : '') }}</div>
            <div v-if="data.insurance && data.insurance.hljRegionDesc" class="userInfo bottomMargin">异地医保：{{ data.insurance.hljRegionDesc }}</div>
            <div class="userInfo bottomMargin">销售单号：{{ data.saleOrder.orderNo }}</div>
            <div class="userInfo bottomMargin">交易时间：{{ data.saleOrder.createTime|formatDateToMin }}</div>
            <div class="userInfo bottomMargin">药房电话：{{ baseInfo.storeInfo.phone }}</div>
            <div class="userInfo">药房地址：{{ baseInfo.storeInfo.address }}</div>
          </div>
          <div class="infos" v-if="data.retailType === 1">
            <div v-for="(item,index) in data.goodsList" :key="index" >
              <div class="userInfoMessage" v-if="item.isRxPrescription === 1"><span class="specialText">单</span><span>为单轨处方药</span></div>
              <div class="userInfoMessage" v-if="item.isRxRegister === 1" ><span class="specialText">双</span><span>为双轨处方药</span></div>
              <div class="userInfoMessage" v-if="item.isExpring === 1"><span class="specialText">近</span><span>为近效期药品</span></div>
              <div class="userInfoMessage" v-if="item.isColdChain === 1"><span class="specialText">冷</span><span>为冷链药品</span></div>
              <div class="userInfoMessage" v-if="item.isEphedrineDrugs === 1"><span class="specialText">麻</span><span>为含麻黄碱类药品 </span></div>
              <div class="userInfoMessage" v-if="item.isDope === 1"><span class="specialText">兴</span><span>为含兴奋剂成分药品，运动员慎用！ </span></div>
              <div class="userInfoMessage" v-if="item.isMedicare === 1"><span class="specialText">医</span><span>为医保药品 </span></div>
            </div>
          </div>
          <div class="infos">
            <div class="userInfo">{{ data.retailType === 2? "医疗器械" : "药品" }}为特殊商品，除质量原因外，一经售出概不退换！</div>
          </div>
        </div>


      </div>
    </printSheet>
  </div>
</template>
<script>
import printJS from 'print-js';
import printSheet from '../printSheet.vue';

export default {
  name: 'printBill',
  components: { printSheet },
  computed: {
    baseInfo() {
      // console.log(this.$store.state, 'this.$store.state');
      return this.$store.state;
    },
    pages() {
      return {
        size: 6,
        all: Math.ceil((this.data.goodsList.length / 6)),
      };
    },
    // data.retailType() {
    //   return this.data.data.retailType;
    // },
  },
  props: {
    data: {

    },
    type: {
      type: Number,
      default: 1,

    },
    ifShowDosageform: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
     
    };
  },

  methods: {
    print() {
      this.delMoreDosage();
      this.$nextTick(() => {
        if (this.type === 1) {
          printJS({
            printable: 'printArea',
            type: 'html',
            css: '../print.css', // 处理SaaS话带来的影响，后续优化
          });
        } else {
          this.$print(this.$refs.printArea);
        }
      });
    },
    delMoreDosage() { //这个函数是为了在打印的时候去掉系统中存在的部分药品剂型字段过长的问题
      if (this.data.goodsList) {
        this.data.goodsList.forEach((item) => {
          if (item.saleOrderDetail.dosageForm) {
            let index = item.saleOrderDetail.dosageForm.indexOf('（');
            if (index >= 0) {
              item.saleOrderDetail.dosageForm = `(${item.saleOrderDetail.dosageForm.slice(0, index)})`;
              return
            }
            item.saleOrderDetail.dosageForm = `(${item.saleOrderDetail.dosageForm})`;
          }
        })
      }
    }
  },
};
</script>
<style lang="less" scoped>
.saleBill2{
  color: #000;
  >div{

    height: 520px;
    .sheetTitle{
      text-align: center;
    }
  }
table {
  border-collapse: collapse;
  width: 100%;

  thead {
    td {
      background: #eee;
     span{

      //  line-height: 36px
     }
    }
  }

  td {
  color: #000;
    border: 1px solid #ccc;
    font-size: 12px;
    text-align: center;
    >span{
    overflow: hidden;
    max-height: 36px;
      display: inline-block;
      align-self:center;

    word-break: break-all;
    word-wrap: wrap;
      // height: 100%;
      width: 100%
    }
  }

  tr {
    td:nth-child(1) {
      width: 18%
    }

    td:nth-child(2) {
      width: 12%
    }

    td:nth-child(3) {
      width: 12%
    }

    td:nth-child(4) {
      width: 8%
    }

    td:nth-child(5) {
      width: 12%
    }

    td:nth-child(6) {
      width: 7%
    }

    td:nth-child(7) {
      width: 7%
    }

    td:nth-child(8) {
      width: 7%
    }

    td:nth-child(9) {
      width: 7%
    }
    td:nth-child(10) {
      width: 7%
    }
  }
}
  .specialText {
    border: 0.5px solid black;
    /* margin-right: 10px; */
    margin-right: 8px;
    text-align: center;
    font-size: 12px
}
  }
  .bill{

    .blockDisplay{
      width: 125%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .firstRowDrug {
    }
  .table {
    width: 125%;
  }
  .sheetTitle {
    width: 125%;
  }
  .spLine {
    width: 125%;
  }
  .subTable {
    width: 125%;
  }
  .payData {
    width: 125%;
  }
  .infos {
    width:125%;
  }
  }
</style>
